import React from 'react';
import { X, Calendar } from 'lucide-react';
import '../styles/booking.css';
import '../styles/doctor-booking-flow.css';

const DoctorDetailsModal = React.memo(({ doctor, onNext, onClose }) => {
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="doctor-details-title"
    >
      <div className="modal-content doctor-details-modal" onClick={(e) => e.stopPropagation()}>
        <button 
          className="modal-close" 
          onClick={onClose} 
          type="button"
          aria-label="Закрити вікно"
        >
          <X size={24} />
        </button>

        <div className="doctor-details-scrollable">
          <div className="doctor-details-content">
          <div className="doctor-photo-container">
            <img 
              src={doctor.image} 
              alt={`Фото лікаря ${doctor.name}`}
              className="doctor-photo"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="doctor-info">
            <h2 id="doctor-details-title" className="doctor-name">{doctor.name}</h2>
            <p className="doctor-position">{doctor.position}</p>
            <p className="doctor-experience">{doctor.experience}</p>
            <p className="doctor-specialization">{doctor.specialization}</p>
          </div>

          {doctor.bio && (
            <div className="doctor-bio">
              <p>{doctor.bio}</p>
            </div>
          )}

          {doctor.education && doctor.education.length > 0 && (
            <div className="doctor-section">
              <h3 className="doctor-section-title">Освіта та сертифікати</h3>
              <ul className="doctor-list">
                {doctor.education.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {doctor.achievements && doctor.achievements.length > 0 && (
            <div className="doctor-section">
              <h3 className="doctor-section-title">Досягнення</h3>
              <ul className="doctor-list">
                {doctor.achievements.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {doctor.services && doctor.services.length > 0 && (
            <div className="doctor-section">
              <h3 className="doctor-section-title">Спеціалізація</h3>
              <ul className="doctor-list doctor-services-list">
                {doctor.services.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}
          </div>
        </div>

        <div className="doctor-details-footer">
          <button 
            className="submit-btn doctor-action-btn" 
            onClick={onNext}
            aria-label={`Записатися до лікаря ${doctor.name}`}
          >
            <Calendar size={20} aria-hidden="true" />
            Записатися до лікаря
          </button>
        </div>
      </div>
    </div>
  );
});

DoctorDetailsModal.displayName = 'DoctorDetailsModal';

export default DoctorDetailsModal;
